const UtilsFunctions = {
  copyArray: function<T>(source: T[]): T[] {
    let cloned = source.map(x => Object.assign({}, x));
    return cloned;
  },
  scrollTo: function(element: any, to: number, duration: number, punchy?: boolean) {

    if(punchy /*&& element.scrollTop >= window.innerHeight * 2*/){
      element.scrollTop = to
    }
    else{
      if (duration < 0) return;
      var difference = to - element.scrollTop;
      var perTick = (difference / duration) * 2;
  
      setTimeout(function() {
        element.scrollTop = element.scrollTop + perTick;
        UtilsFunctions.scrollTo(element, to, duration - 2);
      }, 10);
    }
  },
  sleep: function(milliseconds: number) {
    return new Promise(resolve => setTimeout(resolve, milliseconds))
  }
};

declare global {
  interface Window { SSOOpenWindows: any; }
}

window.SSOOpenWindows = window.SSOOpenWindows || [];

export const storeChildWindows = (windowId:any) => {
  if(windowId !== undefined && windowId !== null)
    window.SSOOpenWindows.push(windowId);
} 

export const closeChildWindows = () => {
  if(window.SSOOpenWindows === undefined || window.SSOOpenWindows === null)
    return;
  for(var i=0;i<window.SSOOpenWindows.length;i++){
    try{window.SSOOpenWindows[i].close();}catch(e){}
  }
  window.SSOOpenWindows = [];
} 

export default UtilsFunctions;
